export const promotersConfig = [
  {
    id: '9900',
    name: 'Sistema eFactura',
    loginType: 'API_LOGIN',
    urlPRE: 'http://sfe-pre-docker-01:9920/sfe/login',
    urlPRO: 'https://efactura.sistemaefactura.com/sfe/login'
  },
  {
    id: '9901',
    name: 'RSI',
    loginType: 'API_LOGIN',
    urlPRE: 'http://sfe-pre-docker-01:9960/rsi/login',
    urlPRO: 'https://rsi.sistemaefactura.com/rsi/login'
  },
  {
    id: '3035',
    name: 'Laboral Kutxa',
    loginType: 'API_LOGIN',
    urlPRE: 'http://sfe-pre-docker-01:9910/cajalaboral/login',
    urlPRO: 'https://cajalaboral.sistemaefactura.com/cajalaboral/login'
  },
  {
    id: '9902',
    name: 'Rioja',
    loginType: 'API_LOGIN',
    urlPRE: 'http://sfe-pre-docker-01:9950/rioja/login',
    urlPRO: 'http://sfe-swarm.ibm.eurobits.es:9102/rioja/login'
  },
  {
    id: '9905',
    name: 'JCyL',
    loginType: 'API_LOGIN',
    urlPRE: 'http://sfe-pre-docker-01:9930/jcyl/login',
    urlPRO: 'https://jcyl.sistemaefactura.com/jcyl/'
  },
  {
    id: '9909',
    name: 'Banqup',
    loginType: 'API_LOGIN',
    urlPRE: 'http://sfe-pre-docker-01:9920/sfe/login',
    urlPRO: 'https://efactura.sistemaefactura.com/sfe/login'
  }
]

export const environmentConfig = [
  {
    id: 'PRE',
    name: 'Preproducción'
  },
  {
    id: 'PRO',
    name: 'Producción'
  }
]

export default {
  promotersConfig,
  environmentConfig
}
